import routerOptions0 from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}